export const enLanguage = {
  Home: "Home",
};
